var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    { staticClass: "btn_today", on: { click: _vm.selectToday } },
    [_vm._v("오늘")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }